import { FacetFiltersForm, PriceRange, FacetRemove } from './js/facets';
import { getFocusableElements, trapFocus, focusVisiblePolyfill, pauseAllMedia, removeTrapFocus, onKeyUpEscape, QuantityInput, debounce, fetchConfig,
MenuDrawer,
HeaderDrawer,
ModalDialog,
ModalOpener,
DeferredMedia,
SliderComponent,
SlideshowComponent,
VariantSelects,
VariantRadios } from './js/global';
import { CustomerAddresses } from './js/customer';
import { CartNotification } from './js/cart-notification';
import { CartRemoveButton, CartItems, CartDrawer } from './js/cart';
import { DetailsDisclosure } from './js/details-disclosure';
import { DetailsModal } from './js/details-modal';
import { MediaGallery } from './js/media-gallery';
import { PasswordModal } from './js/password-modal';
import { PickupAvailability, PickupAvailabilityDrawer} from './js/pickup-availability';
import { PredictiveSearch } from './js/predictive-search';
import { ProductForm } from './js/product-form';

import { ProductModel } from './js/product-model';
import { ProductModal } from './js/product-modal';
import { ShareButton } from './js/share';
import './js/theme-editor';

window.onload = () => {
	typeof CustomerAddresses !== 'undefined' && new CustomerAddresses();
}

window.getFocusableElements = getFocusableElements
window.trapFocus = trapFocus
window.focusVisiblePolyfill = focusVisiblePolyfill
window.pauseAllMedia = pauseAllMedia
window.removeTrapFocus = removeTrapFocus
window.onKeyUpEscape = onKeyUpEscape
window.QuantityInput = QuantityInput
window.debounce = debounce
window.fetchConfig = fetchConfig